import { footerLinks } from '@/mocks/homepage';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-200/70 border-t border-background-300/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {footerLinks.sections.map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-base text-foreground-900 mb-4">
                <a href="#hero" className="no-underline text-foreground-900 hover:text-primary-500 transition-colors">
                  {section.title}
                </a>
              </h4>
              {section.links.length > 0 ? (
                <ul className="space-y-2.5">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 no-underline"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-foreground-500">敬请期待</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; 2025 番茄漫画 - 免费漫画全集大全。海量韩漫、日漫、国漫高清免费在线阅读平台。
          </p>
          <div className="flex items-center gap-5">
            <a href="#contact" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline whitespace-nowrap">
              联系我们
            </a>
            <a href="#faq" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline whitespace-nowrap">
              用户协议
            </a>
            <a href="#faq" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline whitespace-nowrap">
              隐私政策
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}